/* eslint-disable no-undef */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable react/no-array-index-key */
import React from 'react';
import { ReactComponent as LocationIcon } from '../../../../assets/svg/company-icon/location.svg';
import ToolTip from '../ToolTip';

const CompanyLocation = props => {
  const {
    city = '',
    state = '',
    country = '',
    parentClass = '',
    clsName = '',
    showToolTipOnHover = false,
  } = props;
  let str = '';
  if (city !== undefined && city !== null && city !== '') str += city;
  if (state !== undefined && state !== null && state !== '')
    if (str !== '') str += `,&nbsp;${state}`;
    else str += state;
  if (country !== undefined && country !== null && country !== '')
    if (str !== '') str += `,&nbsp;${country}`;
    else str += country;
  let titleStr = str;
  while (titleStr.includes('&nbsp;')) titleStr = titleStr.replace('&nbsp;', '');
  return titleStr !== '' ? (
    <div
      className={`company-location icon-wrap toolTipParentWrap ${parentClass}`}
    >
      <LocationIcon className="svg-icon" />
      <div
        className={`item-name show-elipsis ${clsName}`}
        title={showToolTipOnHover ? '' : titleStr || 'Unavailable'}
        dangerouslySetInnerHTML={{ __html: str || 'Unavailable' }}
      />
      {showToolTipOnHover && <ToolTip toolTipText={str} />}
    </div>
  ) : (
    ''
  );
};

export { CompanyLocation };
export default CompanyLocation;
